"use client";

import { BaseCarouselCore, type BaseCarouselProps } from "./Core";
import styles from "./styles.module.scss";

const BaseCarousel = (props: BaseCarouselProps) => <BaseCarouselCore {...props} classes={styles} />;

export type { BaseCarouselClasses, BaseCarouselProps } from "./Core";
export default BaseCarousel;
